import RegulatoryTableBody from "./components/RegulatoryTableBody/RegulatoryTableBody";
import RegulatoryTableHead from "./components/RegulatoryTableHead/RegulatoryTableHead";
import * as S from "./RegulatoryTable.style";

const RegulatoryTable = () => {
  return (
    <S.RegulatoryTable>
      <RegulatoryTableHead />
      <RegulatoryTableBody />
    </S.RegulatoryTable>
  );
};

export default RegulatoryTable;
